import SingleSelect from "components/Form/Select/SingleSelect";
import { SelectFieldProps } from "components/Form/typings";
import FormField from "../FormField";

export default function SingleSelectField({
  name,
  label,
  placeholder,
  isClearable,
  control,
  options,
  errors,
  required,
  disabled,
  menuPlacement,
  variant,
  formFieldProps = {},
  ...rest
}: SelectFieldProps) {
  const formVariant = variant;
  return (
    <FormField
      name={name}
      label={label}
      errors={errors}
      required={required}
      disabled={disabled}
      variant={formVariant}
      {...formFieldProps}
    >
      <SingleSelect
        isClearable={isClearable ?? true}
        useBasicStyles
        name={name}
        variant={formVariant}
        control={control}
        placeholder={formVariant === "floating" ? " " : placeholder}
        options={options}
        menuPlacement={menuPlacement}
        {...rest}
      />
    </FormField>
  );
}
